export default [
    {
        id: 4,
        label: 'Booking Cancellation',
        shortName: 'CNX',
    },
    {
        id: 3,
        label: 'Booking Confirmation',
        shortName: 'CNF',
    },
];



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-fax/fax-document-types.js